


function merchant(prefix: string) {
  
  return {
    ROOT: prefix,
    MERCHANT_REQUEST: `${prefix}/merchant-request`,
    MERCHANT_REQUEST_VALIDATION: `${prefix}/merchant-request-validation`,
    MERCHANT_CONSULTATION: `${prefix}/merchant-consultation`,
    MERCHANT_CONSULTATION_DETAILS: `${prefix}/merchant-consultation/details/`,
  }
}

function gabManagement(prefix: string) {
  // BANK Menu Routes
  const BANK_PATH = `${prefix}/bank/`;
  
  const BANK_MENU = {
      ROOT: BANK_PATH,
      FDK_CONFIGURATION: `${BANK_PATH}fdk-configuration`,
      
      CONFIGURATION: `${BANK_PATH}configuration`,
      
  };

  // GLOBAL SETTINGS Menu Routes
  const GLOBAL_SETTINGS_PATH = `${prefix}/global-settings/`;
      
  const GLOBAL_SETTINGS_MENU = {
      ROOT: GLOBAL_SETTINGS_PATH,
      
      GROUP: `${GLOBAL_SETTINGS_PATH}group`,
      
      FITS_GROUP: `${GLOBAL_SETTINGS_PATH}fits-group`,
      
      FINANCIAL_INSTITUTES_TABLE: `${GLOBAL_SETTINGS_PATH}financial-institutes-table`,
      
      FDK_VALUES: `${GLOBAL_SETTINGS_PATH}fdk-values`,
      
      DESIGNATION: `${GLOBAL_SETTINGS_PATH}designation`,
      
      PRINT_SETTING: `${GLOBAL_SETTINGS_PATH}print-setting`,

  };

  // TERMINAL Menu Routes
  const TERMINAL_PATH = `${prefix}/terminal/`;
  const TERMINAL_MENU = {
      ROOT: TERMINAL_PATH,
      SALES_POINT: `${TERMINAL_PATH}sales-point`,
      TERMINAL: `${TERMINAL_PATH}terminal`,
      LOG_EVENT: `${TERMINAL_PATH}log-event`,
      CAPTURED_CARD: `${TERMINAL_PATH}captured-card`,
      OUT_OF_SERVICE_TERMINAL: `${TERMINAL_PATH}out-of-service-terminal`,
      MONITORING: `${TERMINAL_PATH}monitoring`,
      GAB_TRANSACTION: `${TERMINAL_PATH}gab-transaction`,
  };

  return {
      ROOT: prefix,
      BANK_MENU,
      GLOBAL_SETTINGS_MENU,
      TERMINAL_MENU,
      
  }
}

export function terminalManagementSystem(prefix: string) {
  return {
    ROOT: prefix,
    // GAB Management
    GAB_MANAGEMENT: {
      ...gabManagement(`${prefix}/gab-management`)
    },
    // Merchant
    MERCHANT: {
      ...merchant(`${prefix}/merchant`)
    },
  }
}